import * as yup from 'yup'

export const documentStepSchema = (international) =>
  yup.object().shape({
    document: international
      ? yup.string().required()
      : yup.string().required().cpfOrCnpj('Documento inválido'),
  })

export const emailStepSchema = (isFirstAccess) =>
  yup.object().shape({
    ...(isFirstAccess && { name: yup.string().required() }),
    email: yup.string().email().required(),
  })

export const twoFactorAuthenticationStepSchema = yup.object().shape({
  code: yup.string().required(),
})
